import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';

import './ApiKeysTable.css';

var MaterialSymbol = function(props) {
  var name = props.name;
  var className = props.className || '';
  return (
    <span
      className={'material-symbols-outlined ' + className}
      style={{ fontSize: 18, lineHeight: 1 }}
    >
      {name}
    </span>
  );
};

var getLastFour = function(apiKey) {
  return apiKey.lastFourChars || '';
};

var ApiKeysTable = function(props) {
  var apiKeys = props.apiKeys;
  var onDelete = props.onDelete;
  var disabled = props.disabled;
  var loading = props.loading;
  var t = props.t;

  // Show loader while loading OR if apiKeys hasn't been fetched yet (null/undefined)
  if (loading || apiKeys === null || apiKeys === undefined) {
    return (
      <div className="apikeys-loading">
        <BeatLoader color="#f15a29" size={10} />
      </div>
    );
  }

  // Only show empty state when we have confirmed the array is empty
  if (apiKeys.length === 0) {
    return (
      <div className="apikeys-empty-state">
        {t('stackSettings:noApiKeys')}
      </div>
    );
  }

  return (
    <div className="apikeys-table-container">
      <table className="apikeys-table">
        <thead className="apikeys-table-header">
          <tr>
            <th className="apikeys-table-th">{t('common:name')}</th>
            <th className="apikeys-table-th">{t('stackSettings:lastFourCharacters')}</th>
            <th className="apikeys-table-th apikeys-table-th--actions"></th>
          </tr>
        </thead>
        <tbody>
          {apiKeys.map(function(apiKey) {
            return (
              <tr key={apiKey.uuid} className="apikeys-table-row">
                <td className="apikeys-table-cell apikeys-table-cell--name">
                  {apiKey.name}
                </td>
                <td className="apikeys-table-cell apikeys-table-cell--key">
                  <span className="apikeys-key-value">{getLastFour(apiKey)}</span>
                </td>
                <td className="apikeys-table-cell apikeys-table-cell--actions">
                  <button
                    type="button"
                    className="apikeys-btn--delete"
                    onClick={function() { onDelete(apiKey.uuid); }}
                    disabled={disabled}
                    aria-label={t('btn:delete')}
                    title={t('btn:delete')}
                  >
                    <MaterialSymbol name="delete" />
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

ApiKeysTable.propTypes = {
  apiKeys: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      last4: PropTypes.string,
      apiKey: PropTypes.string,
    })
  ),
  onDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

ApiKeysTable.defaultProps = {
  apiKeys: null,
  disabled: false,
  loading: false,
};

export default withTranslation()(ApiKeysTable);
